export const sharedSentryOptions = {
	environment: process.env.NX_PUBLIC_ENVIRONMENT,
	release: process.env.NX_PUBLIC_APP_VERSION,
	tracesSampleRate: 0.01,
} as const;
